function initHeroAudioToggle(toggle) {
  if (!toggle) return;

  const section = toggle.closest('.section-hero');
  if (!section) return;

  const videos = [...section.querySelectorAll('.section-hero__background .section-hero__video')];
  if (!videos.length) return;

  let isMuted = true;

  const applyIconState = () => {
    const soundOnIcon = toggle.querySelector('.hero-audio-toggle__icon--sound-on');
    const mutedIcon = toggle.querySelector('.hero-audio-toggle__icon--muted');

    if (soundOnIcon && mutedIcon) {
      if (isMuted) {
        soundOnIcon.classList.add('is-hidden');
        mutedIcon.classList.remove('is-hidden');
        toggle.classList.add('hero-audio-toggle--is-muted');
      } else {
        soundOnIcon.classList.remove('is-hidden');
        mutedIcon.classList.add('is-hidden');
        toggle.classList.remove('hero-audio-toggle--is-muted');
      }
    }

    toggle.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
  };

  const setVideosMuted = (muted) => {
    videos.forEach((video) => {
      if (video) video.muted = muted;
    });
  };

  setVideosMuted(true);
  applyIconState();

  const handleToggle = () => {
    isMuted = !isMuted;
    setVideosMuted(isMuted);

    if (!isMuted) {
      videos.forEach((v) => v?.play?.());
    }

    applyIconState();
  };

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    handleToggle();
  });

  toggle.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleToggle();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hero-audio-toggle').forEach(initHeroAudioToggle);
});
